export enum DeliveryMethod {
  pickup = 'pickup',
  asmPickup = 'asm-pickup',
  standard = 'standard',
  dpdPickup = 'dpd-pickup',
  asmStardard = 'asm-standard',
  asmStandardFree = 'asm-standard-free',
  asmCrossBoroder = 'asm-cross-border',
  inpost = 'inpost',
  asmInpost = 'asm-inpost',
  pocztaPolskaOrlenZabka = 'post-pickup-orlen-zabka',
  pocztaPolskaOthers = 'post-pickup-others',
  pharmaLink = 'pharmalink',
  email = 'email'
}

export enum DeliveryMode {
  dpd = 'dpd',
  dpdPickup = 'dpd-pickup',
  pharmaLink = 'pharmalink',
  email = 'email',
  pickup = 'pickup',
  inpost = 'inpost',
  pocztaPolskaOrlenZabka = 'post-pickup-orlen-zabka',
  pocztaPolskaOthers = 'post-pickup-others'
}
